import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://622c6cf336483ae4a493f4b44f56dd17@o4507589124685824.ingest.de.sentry.io/4508930824863824",
    environment: process.env.NODE_ENV,
  });
}

import axios from "axios";
import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { API_URL } from "./constants/environment";
import AppRoutes from "./routing/AppRoutes";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { fr } from "date-fns/locale/fr";
import "./lib/toastify.css";
import "react-tooltip/dist/react-tooltip.css";
import { TooltipProvider } from "./components/ui/tooltip";
import { Provider } from "jotai";
import { authStore } from "./stores/authStore";
import { LogoutHandler } from "./components/LogoutHandler";
import { AppErrorBoundary } from "./components/appErrorBoundary";

const App = () => {
  axios.defaults.baseURL = API_URL;

  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Provider store={authStore}>
            <BrowserRouter>
              <LogoutHandler />
              <ScrollToTop />
              <AppErrorBoundary>
                <AppRoutes />
              </AppErrorBoundary>
            </BrowserRouter>
            <ToastContainer
              position="top-right"
              style={{
                fontSize: "1.2rem",
                width: "fit-content",
              }}
            />
          </Provider>
        </TooltipProvider>
      </QueryClientProvider>
    </LocalizationProvider>
  );
};

export default App;
